
import img1 from '../Gallery-Images/Bobcat.JPG'
import img2 from '../Gallery-Images/Bull_2.JPG'
import img3 from '../Gallery-Images/deer_nature.JPG'
import img4 from '../Gallery-Images/Dogs.JPG'
import img5 from '../Gallery-Images/Euros.JPG'
import img6 from '../Gallery-Images/lifesize_deer.jpg'
import img7 from '../Gallery-Images/IMG_2832.JPG'
import img8 from '../Gallery-Images/Double_ped.jpg'
import img9 from '../Gallery-Images/image9.jpeg'
import img10 from '../Gallery-Images/turkey.jpg'
import img11 from '../Gallery-Images/Mexico_deer.jpg'
import img12 from '../Gallery-Images/img-shop.JPG'
import img13 from '../Gallery-Images/img-goat.JPG'
import img14 from '../Gallery-Images/IMG_3111.JPG'
import img15 from '../Gallery-Images/IMG_3093.JPG'
import img16 from '../Gallery-Images/IMG_420.JPG'
import img17 from '../Gallery-Images/IMG_1572.JPG'
import img18 from '../Gallery-Images/IMG_1375.JPG'
import img19 from '../Gallery-Images/IMG_0491 (1).JPG'
import img20 from '../Gallery-Images/IMG_0356.JPG'
import img21 from '../Gallery-Images/IMG_0264.JPG'
import img22 from '../Gallery-Images/IMG_0043 (1).JPG'
import img23 from '../Gallery-Images/Goats.JPG'
import img24 from '../Gallery-Images/Ducks.JPG'
import img25 from '../Gallery-Images/Coyote.JPG'
import img26 from '../Gallery-Images/baby_elk.JPG'
import img27 from '../Gallery-Images/Goat_1.JPG'
import img28 from '../Gallery-Images/IMG_1366.JPG'



export const GalleryData = [
    {
        id: 1,
        imgSrc: img1
    },
    {
        id: 2,
        imgSrc: img2
    },
    {
        id: 3,
        imgSrc: img3
    },
    {
        id: 4,
        imgSrc: img4
    },
    {
        id: 5,
        imgSrc: img5
    },
    {
        id: 6,
        imgSrc: img10
    },
    {
        id: 7,
        imgSrc: img7
    },
    {
        id: 8,
        imgSrc: img8
    },
    {
        id: 9,
        imgSrc: img9
    },
    {
        id: 10,
        imgSrc: img6
    },
    {
        id: 11,
        imgSrc: img11
    },
    {
        id: 12,
        imgSrc: img12
    },
    {
        id: 13,
        imgSrc: img13
    },
    {
        id: 14,
        imgSrc: img14
    },
    {
        id: 15,
        imgSrc: img15
    },
    {
        id: 16,
        imgSrc: img16
    },
    
    {
        id: 17,
        imgSrc: img17
    },
    {
        id: 18,
        imgSrc: img18
    },
    {
        id: 19,
        imgSrc: img19
    },
    {
        id: 20,
        imgSrc: img21
    },
    {
        id: 21,
        imgSrc: img20
    },
    {
        id: 22,
        imgSrc: img22
    },
    {
        id: 23,
        imgSrc: img23
    },
    {
        id: 24,
        imgSrc: img24
    },
    {
        id: 25,
        imgSrc: img25
    },
    {
        id: 26,
        imgSrc: img26
    },
    {
        id: 27,
        imgSrc: img27
    },
    {
        id: 28,
        imgSrc: img28
    },
    


  ]
  



